module.exports = __webpack_public_path__ + "img/14.319028fd.jpg";